"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PREVIEW_SEE_ALL_RESULTS = exports.SEARCH_PREVIEW = exports.QUERY_NAME = exports.MAX_SEARCH_HEIGHT = void 0;
const SEARCH_PREVIEW = exports.SEARCH_PREVIEW = 'search-preview';
const SEARCH_PREVIEW_SEE_ALL_RESULTS = exports.SEARCH_PREVIEW_SEE_ALL_RESULTS = 'search-preview-see-all-results';
const MAX_SEARCH_HEIGHT = exports.MAX_SEARCH_HEIGHT = 630;
const QUERY_NAME = exports.QUERY_NAME = 'query';
